import axios from "axios";
import { authenticateService } from "./CommonService";
import { client } from "../Context/orgContext";

export const getDashboardData = async ({page,sort,filter,searchParam,selectedClinicCode}) => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/assessmentReportStats/getAssessmentReportStats?page=${page}&size=20&organisationDomainName=${client}&clinicCode=${selectedClinicCode}&sort=${sort}&filter=${filter}&search=${searchParam}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }
};

export const getPdfUrl = async (id) => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/assessmentReportStats/getPdfUrl?encryptedSessionId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
};

export const getExportReportUrl = async (id) => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/exportExcel?encryptedSessionId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
};

export const getDashboardUsers = async ({page, sort,filter,searchParam, selectedClinicCode}) => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/assessmentReportStats/getUniqueAssessmentReportStats?page=${page}&size=20&organisationDomainName=${client}&clinicCode=${selectedClinicCode}&sort=${sort}&filter=${filter}&search=${searchParam}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }
};

export const getUserDetails = async (userId) => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/getEndUserDetails?endUserId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }
};

export const getProgressiveDataForUser = async (userId) => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/assessmentReportStats/getProgressiveReport?userId=${userId}&organisationDomainName=${client}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }
};

export const getPainTrackingData = async (userId) => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/painTracking?userId=${userId}&formName=assessment-feedback-form&orgDomainName=${client}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }
};

export const getBodyPartExerciseStatsByUserId = async (userId) => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/assessmentReportStats/bodyPartExerciseStat/User?userId=${userId}&organisationDomainName=${client}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }
};

export const getPopulationData = async ({graphYear,selectedClinicCode}) => {
  const token = await authenticateService();
  const currentYear = new Date().getFullYear();
  const year = graphYear ? graphYear : currentYear;
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/populationAnalytics?orgDashboardDomainName=${client}&clinicCode=${selectedClinicCode}&year=${year}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }
};

export const archiveUserService = async (userId, flag) => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/archiveUser?userId=${userId}&archive=${flag}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        return response.data;
      });
  }
};

export const exportUsersData = async () => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/exportUsersData?orgDomainName=${client}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        return response.data;
      });
  }
};

export const sendWebHookHandler = async(id) => {
  const token = await authenticateService();
  if(token.jwt){
    console.log("sendWebHookHandler" ,id);
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/sendDataToWebhook?encryptedSessionId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log("sendWebHookHandler");
        return response.data;
      });
  }
}
